var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBaoguang = function SvgBaoguang(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#baoguang_svg__a)",
    fill: "#018DD7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.718 4.31h-3.136l-4.1-4.06-.036-.036-.071-.071-.036-.036h-.036a.684.684 0 0 0-.642.036c-.036.036-.107.07-.142.107l-4.06 4.06H2.246A2.237 2.237 0 0 0 0 6.557v11.159a2.236 2.236 0 0 0 2.246 2.245h15.509A2.236 2.236 0 0 0 20 17.716V6.556a2.29 2.29 0 0 0-2.282-2.246Zm-7.7-2.603L12.62 4.31H7.379l2.639-2.603Zm8.52 15.83a.996.996 0 0 1-.998.997H2.425a.998.998 0 0 1-.998-.998V6.698a.997.997 0 0 1 .998-.998H4.06l1.962-.037h8.02l1.962.037h1.604a.997.997 0 0 1 .998.998l-.071 10.838h.003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.01 10.015H4.99a.713.713 0 1 0 0 1.425h10.02a.713.713 0 0 0 0-1.425Zm0 4.277H4.99a.713.713 0 1 0 0 1.426h10.02a.713.713 0 0 0 0-1.425Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "baoguang_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};

export default SvgBaoguang;